"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLineItemPrice = exports.getNearbyHomesNoMap = exports.getFeaturedPublishedProjectsInViewport = exports.getImageIds = exports.getHeroImageId = exports.getDefaultPopupContent = exports.projectCompleted = exports.hasEnrichedData = exports.getRandomizedCoordinates = exports.getURL = exports.getStage = exports.getMetadata = exports.getProjectNumber = exports.getCompletionYear = exports.getProjectDurationMonths = exports.getEndDate = exports.getStartDate = exports.getTotalPrice = exports.showPriceBreakdown = exports.getTotalSiteWorkPrice = exports.getProductTitle = exports.getProjectTitle = exports.getProductPrice = exports.getProduct = exports.getPublishedFeaturedProjects = exports.HOVER_IMAGE_RESOLUTION = void 0;
const core_1 = require("@natomas-org/core");
const helpers_1 = require("../helpers");
const geofire_common_1 = require("geofire-common");
const PublicProjectMetadataAccessor_1 = require("../PublicProjectMetadata/PublicProjectMetadataAccessor");
exports.HOVER_IMAGE_RESOLUTION = "500";
const getPublishedFeaturedProjects = (projects) => {
    return projects === null || projects === void 0 ? void 0 : projects.filter((project) => {
        return ((project === null || project === void 0 ? void 0 : project.featured) === true &&
            (project === null || project === void 0 ? void 0 : project.published) === true);
    });
};
exports.getPublishedFeaturedProjects = getPublishedFeaturedProjects;
const getProduct = (projectInfo) => {
    var _a, _b, _c, _d, _e;
    return ((_b = (_a = projectInfo === null || projectInfo === void 0 ? void 0 : projectInfo.metadata) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.length) &&
        ((_d = (_c = projectInfo === null || projectInfo === void 0 ? void 0 : projectInfo.metadata) === null || _c === void 0 ? void 0 : _c.products) === null || _d === void 0 ? void 0 : _d.length) > 0
        ? (_e = projectInfo === null || projectInfo === void 0 ? void 0 : projectInfo.metadata) === null || _e === void 0 ? void 0 : _e.products[0]
        : null;
};
exports.getProduct = getProduct;
const getProductPrice = (projectInfo) => {
    var _a, _b, _c, _d, _e;
    const product = (0, exports.getProduct)(projectInfo);
    const productPriceMicros = (_e = (_b = (_a = product === null || product === void 0 ? void 0 : product.price) === null || _a === void 0 ? void 0 : _a.price) !== null && _b !== void 0 ? _b : (_d = (_c = projectInfo === null || projectInfo === void 0 ? void 0 : projectInfo.metadata) === null || _c === void 0 ? void 0 : _c.totalProductPrice) === null || _d === void 0 ? void 0 : _d.price) !== null && _e !== void 0 ? _e : null;
    if (productPriceMicros) {
        return (0, helpers_1.roundMicrosToNearestDollar)(productPriceMicros);
    }
    return null;
};
exports.getProductPrice = getProductPrice;
const getProjectTitle = (projectDetails) => {
    if (projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.title) {
        // Root title trumps product title
        return projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.title;
    }
    return (0, exports.getProductTitle)(projectDetails);
};
exports.getProjectTitle = getProjectTitle;
const getProductTitle = (projectDetails) => {
    var _a;
    const product = (0, exports.getProduct)(projectDetails);
    if (product) {
        return (_a = product === null || product === void 0 ? void 0 : product.title) !== null && _a !== void 0 ? _a : null;
    }
    return null;
};
exports.getProductTitle = getProductTitle;
const getTotalSiteWorkPrice = (publicProjectDetails) => {
    var _a, _b, _c, _d;
    if (!((_b = (_a = publicProjectDetails === null || publicProjectDetails === void 0 ? void 0 : publicProjectDetails.metadata) === null || _a === void 0 ? void 0 : _a.totalSiteWorkPrice) === null || _b === void 0 ? void 0 : _b.price)) {
        return null;
    }
    return (0, helpers_1.roundMicrosToNearestDollar)((_d = (_c = publicProjectDetails === null || publicProjectDetails === void 0 ? void 0 : publicProjectDetails.metadata) === null || _c === void 0 ? void 0 : _c.totalSiteWorkPrice) === null || _d === void 0 ? void 0 : _d.price);
};
exports.getTotalSiteWorkPrice = getTotalSiteWorkPrice;
const showPriceBreakdown = (publicProjectInfo) => {
    const unitPriceMicros = (0, exports.getProductPrice)(publicProjectInfo);
    const permitPriceMicros = (0, exports.getLineItemPrice)(publicProjectInfo, core_1.LineItemType.PERMIT_LINE_ITEM_ID);
    const siteWorkPriceMicros = (0, exports.getTotalSiteWorkPrice)(publicProjectInfo);
    return (!!unitPriceMicros &&
        unitPriceMicros > 0 &&
        !!permitPriceMicros &&
        permitPriceMicros > 0 &&
        !!siteWorkPriceMicros &&
        siteWorkPriceMicros - permitPriceMicros > 0);
};
exports.showPriceBreakdown = showPriceBreakdown;
const getTotalPrice = (projectDetails) => {
    const siteWorkPrice = (0, exports.getTotalSiteWorkPrice)(projectDetails);
    const productPrice = (0, exports.getProductPrice)(projectDetails);
    if (siteWorkPrice && productPrice) {
        return siteWorkPrice + productPrice;
    }
    return null;
};
exports.getTotalPrice = getTotalPrice;
const getStartDate = (projectDetails) => {
    var _a, _b;
    if ((_a = projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.status_details) === null || _a === void 0 ? void 0 : _a.start_date) {
        return new Date((_b = projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.status_details) === null || _b === void 0 ? void 0 : _b.start_date);
    }
    return null;
};
exports.getStartDate = getStartDate;
const getEndDate = (projectDetails) => {
    var _a, _b;
    if ((_a = projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.status_details) === null || _a === void 0 ? void 0 : _a.end_date) {
        return new Date((_b = projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.status_details) === null || _b === void 0 ? void 0 : _b.end_date);
    }
    return null;
};
exports.getEndDate = getEndDate;
const getProjectDurationMonths = (projectDetails) => {
    const startDate = (0, exports.getStartDate)(projectDetails);
    const endDate = (0, exports.getEndDate)(projectDetails);
    if (!startDate || !endDate) {
        return null;
    }
    return (endDate.getMonth() -
        startDate.getMonth() +
        12 * (endDate.getFullYear() - startDate.getFullYear()));
};
exports.getProjectDurationMonths = getProjectDurationMonths;
const getCompletionYear = (projectDetails) => {
    const endDate = (0, exports.getEndDate)(projectDetails);
    if (!endDate) {
        return null;
    }
    return endDate.getFullYear();
};
exports.getCompletionYear = getCompletionYear;
const getProjectNumber = (projectDetails) => {
    var _a;
    return (_a = projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.number) !== null && _a !== void 0 ? _a : null;
};
exports.getProjectNumber = getProjectNumber;
const getMetadata = (publicProjectInfo) => {
    var _a;
    return (_a = publicProjectInfo === null || publicProjectInfo === void 0 ? void 0 : publicProjectInfo.metadata) !== null && _a !== void 0 ? _a : null;
};
exports.getMetadata = getMetadata;
const getStage = (projectDetails) => {
    var _a, _b;
    return (_b = (_a = projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.status_details) === null || _a === void 0 ? void 0 : _a.stage) !== null && _b !== void 0 ? _b : null;
};
exports.getStage = getStage;
const getURL = (projectDetails) => {
    var _a;
    return (_a = projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.app_url) !== null && _a !== void 0 ? _a : null;
};
exports.getURL = getURL;
const getRandomizedCoordinates = (projectDetails) => {
    var _a, _b, _c, _d;
    if (!!((_a = projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.randomizedCoordinates) === null || _a === void 0 ? void 0 : _a.lng) &&
        !!((_b = projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.randomizedCoordinates) === null || _b === void 0 ? void 0 : _b.lat)) {
        return {
            lat: (_c = projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.randomizedCoordinates) === null || _c === void 0 ? void 0 : _c.lat,
            lng: (_d = projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.randomizedCoordinates) === null || _d === void 0 ? void 0 : _d.lng,
        };
    }
    return null;
};
exports.getRandomizedCoordinates = getRandomizedCoordinates;
const hasEnrichedData = (projectDetails) => {
    return (!!(0, exports.getHeroImageId)(projectDetails) && !!(0, exports.getProjectTitle)(projectDetails));
};
exports.hasEnrichedData = hasEnrichedData;
const projectCompleted = (projectDetails) => {
    var _a;
    // const COMPLETE_STAGES = [
    //   "Complete",
    //   "Closeout",
    //   "Installation",
    //   IProjectStage.COMPLETE,
    //   IProjectStage.CLOSEOUT,
    //   IProjectStage.INSTALLATION,
    // ];
    return ((_a = ((projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.featured) && (projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.published))) !== null && _a !== void 0 ? _a : false);
};
exports.projectCompleted = projectCompleted;
const getDefaultPopupContent = (projectDetails) => {
    const showDuration = false;
    const duration = (0, exports.getProjectDurationMonths)(projectDetails);
    const siteWorkPrice = (0, exports.getTotalSiteWorkPrice)(projectDetails);
    const productPrice = (0, exports.getProductPrice)(projectDetails);
    const completionYear = (0, exports.getCompletionYear)(projectDetails);
    const projectNumber = (0, exports.getProjectNumber)(projectDetails);
    const productTitle = (0, exports.getProjectTitle)(projectDetails);
    const totalPriceDisplay = productPrice && siteWorkPrice
        ? `<h6 class="h6">Total: ${(0, core_1.fullPriceTextFromMicros)(Math.floor(productPrice + siteWorkPrice))}</h6>`
        : "";
    const projectDurationDisplay = !!duration && showDuration
        ? `<h6 class="h6">Duration:
                ${duration}
               Months </h6>`
        : "";
    const projectYearCompleteDisplay = completionYear
        ? `<h6 class="h6">Completion year: ${completionYear}</h6>`
        : "";
    const projectNumberDisplay = `<h3 class="h3">Villa #${projectNumber}
              </h3>`;
    const productTitleDisplay = productTitle
        ? `<h6 class="h6">Unit:
                ${productTitle}
              </h6>`
        : "";
    return `<div>
      ${projectNumberDisplay}${productTitleDisplay}${totalPriceDisplay}
      ${projectYearCompleteDisplay}${projectDurationDisplay}
    </div>`;
};
exports.getDefaultPopupContent = getDefaultPopupContent;
const getHeroImageId = (projectDetails) => {
    var _a;
    return !!(projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.imageIds) && ((_a = projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.imageIds) === null || _a === void 0 ? void 0 : _a.length) > 0
        ? projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.imageIds[0]
        : null;
};
exports.getHeroImageId = getHeroImageId;
const getImageIds = (projectDetails) => {
    var _a;
    return !!(projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.imageIds) && ((_a = projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.imageIds) === null || _a === void 0 ? void 0 : _a.length) > 0
        ? projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.imageIds
        : null;
};
exports.getImageIds = getImageIds;
const getFeaturedPublishedProjectsInViewport = (projectsInViewport) => {
    const arrayToReturn = [];
    if (projectsInViewport && (projectsInViewport === null || projectsInViewport === void 0 ? void 0 : projectsInViewport.length) > 0) {
        projectsInViewport === null || projectsInViewport === void 0 ? void 0 : projectsInViewport.forEach((project) => {
            var _a, _b;
            let projectDetails = (_b = (_a = project === null || project === void 0 ? void 0 : project.feature) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b.projectDetails;
            if (projectDetails) {
                if (typeof projectDetails === "string") {
                    projectDetails = JSON.parse(projectDetails);
                }
                if ((projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.featured) &&
                    (projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.published)) {
                    arrayToReturn.push(projectDetails);
                }
            }
        });
    }
    return arrayToReturn;
};
exports.getFeaturedPublishedProjectsInViewport = getFeaturedPublishedProjectsInViewport;
const getNearbyHomesNoMap = (mapState, completedProjects, count) => {
    const allProjectsArray = completedProjects
        ? Object.values(completedProjects)
        : [];
    const distanceDictionary = {};
    const currentLocationLng = mapState === null || mapState === void 0 ? void 0 : mapState.mLng;
    const currentLocationLat = mapState === null || mapState === void 0 ? void 0 : mapState.mLat;
    if ((allProjectsArray === null || allProjectsArray === void 0 ? void 0 : allProjectsArray.length) > 0 &&
        !!currentLocationLat &&
        !!currentLocationLng) {
        const enrichedPublishedProjects = (0, exports.getPublishedFeaturedProjects)(allProjectsArray);
        // Create a project dictionary where the key is the distance to the center of the current viewport
        enrichedPublishedProjects === null || enrichedPublishedProjects === void 0 ? void 0 : enrichedPublishedProjects.forEach((project) => {
            var _a;
            const projectLng = core_1.Address.getLongitude(core_1.Address.dataToAddress(project === null || project === void 0 ? void 0 : project.project_address));
            const projectLat = core_1.Address.getLatitude(core_1.Address.dataToAddress(project === null || project === void 0 ? void 0 : project.project_address));
            if (!!project && !!projectLng && !!projectLat) {
                if (typeof project === "string") {
                    project = JSON.parse(project);
                }
                if ((_a = mapState === null || mapState === void 0 ? void 0 : mapState.projectsInViewport) === null || _a === void 0 ? void 0 : _a.find((projectWithinViewport) => {
                    var _a, _b;
                    return (((_b = (_a = projectWithinViewport === null || projectWithinViewport === void 0 ? void 0 : projectWithinViewport.feature) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b.code) ==
                        (project === null || project === void 0 ? void 0 : project.code));
                })) {
                    return;
                }
                const distance = (0, geofire_common_1.distanceBetween)([currentLocationLat, currentLocationLng], [projectLat, projectLng]);
                if (distance) {
                    distanceDictionary[distance] = project;
                }
            }
        });
    }
    const keys = [];
    // eslint-disable-next-line guard-for-in
    for (const key in distanceDictionary) {
        keys[keys.length] = Number(key);
    }
    const arrayToReturn = [];
    const sortedKeys = keys.sort(function (a, b) {
        return a - b;
    });
    // Using the distance dictionary, get the first 8 projects with lowest key value.
    let numberToRetrieve = 8;
    if (count) {
        numberToRetrieve = count;
    }
    sortedKeys === null || sortedKeys === void 0 ? void 0 : sortedKeys.forEach((key, idx) => {
        if (idx < numberToRetrieve) {
            arrayToReturn.push(distanceDictionary[key]);
        }
    });
    return arrayToReturn;
};
exports.getNearbyHomesNoMap = getNearbyHomesNoMap;
const getLineItemPrice = (publicProjectInfo, lineItemType) => {
    var _a, _b, _c;
    const siteWorkLineItems = (0, PublicProjectMetadataAccessor_1.getSiteWorkLineItems)((0, exports.getMetadata)(publicProjectInfo));
    if (!siteWorkLineItems) {
        return null;
    }
    const lineItem = (_a = siteWorkLineItems === null || siteWorkLineItems === void 0 ? void 0 : siteWorkLineItems.find((item) => {
        return (item === null || item === void 0 ? void 0 : item.lineItemType) === lineItemType;
    })) !== null && _a !== void 0 ? _a : null;
    if (!((_b = lineItem === null || lineItem === void 0 ? void 0 : lineItem.price) === null || _b === void 0 ? void 0 : _b.price)) {
        return null;
    }
    return (0, helpers_1.roundMicrosToNearestDollar)((_c = lineItem === null || lineItem === void 0 ? void 0 : lineItem.price) === null || _c === void 0 ? void 0 : _c.price);
};
exports.getLineItemPrice = getLineItemPrice;
//# sourceMappingURL=PublicProjectInfoAccessor.js.map